import React from 'react';

//types
import { IIconRotatableProps } from 'assets/icons/IconProps';

export const ArrowRightIcon = ({
  width = 24,
  height = 24,
  rotate = 0,
  stroke = '#DBDDE0',
  strokeWidth = 2,
}: IIconRotatableProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    fill="none"
    viewBox="0 0 24 24"
  >
    <path
      transform={`rotate(${rotate} 12 12)`}
      stroke={stroke}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M5 12h14M12 5l7 7-7 7"
    />
  </svg>
);
